export default __webpack_public_path__ + "static/engagement-542647e4156546afa38b4fc0f1493298.png";